import { find, register } from '../../../../Javascript/Sysmex/Utils'

const NavigationMicrosite = el => {
  const componentPrefix = el.dataset.componentprefix
  const menuToggle = find(`.${componentPrefix}menu-toggler`, el)

  menuToggle.addEventListener('click', () => {
    el.classList.toggle(`${componentPrefix}is--open`)
  })
}

register('NavigationMicrosite', NavigationMicrosite)
